import config from 'config'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'srcReact/components/common2/Button'
import IconButton from 'srcReact/components/common2/IconButton'
import Modal from 'srcReact/components/common2/Modal'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import styles from './styles.module.scss'

function MembersModal({ isOpen, hideModal, members }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    common: { isMobile, isNative }
  } = useSelector((state) => state)

  const handleMemberClick = (user, screen) => {
    const lp = new LightProfileProto()
    lp.userId = user.flag_id_user
    lp.screen = screen || 'main'
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  const handleCreateGroupConv = () => {
    const userIds = members.map((m) => m.flag_id_user)
    hideModal()
    if (isNative) {
      window.location = config.webUrl + `/0/messenger/native/messenger?userid=${userIds.toString()}`
    } else {
      window.location = config.webUrl + `/0/messenger?userid=${userIds.toString()}`
    }
  }

  return (
    <Modal
      {...(isMobile || isNative ? {} : { customContentStyle: { maxWidth: '26rem' } })}
      isOpen={isOpen}
      handleClose={hideModal}
      title={t('moderationReport.flaggedThisContent')}>
      <div className={styles.membersModalWrapper}>
        <div className={styles.membersModal}>
          {members.map((m, idx) => (
            <div className={styles.members} key={idx}>
              <img src={m.flag_user_picture_url} alt={m.flag_user_name} />
              <div className={styles.name}>{m.flag_user_name}</div>
              <IconButton
                type='button'
                onClick={() => handleMemberClick(m, 'messenger')}
                iconName='write'
                iconSize='large24'
                className={styles.startConversationIcon}
              />
            </div>
          ))}
        </div>
        <div className={styles.createGroupOrgBtn}>
          <Button
            text={t('moderationReport.createGroupConversation')}
            size='large'
            style='primary'
            handleClick={handleCreateGroupConv}
          />
        </div>
      </div>
    </Modal>
  )
}

export default MembersModal
